import { computed, ref } from "vue";
import { services } from "../services";

const places = ref<any>([]);
const zones = ref<any>([]);
const selectedZones = ref<any>([]);
const markerSelected = ref({});
const toggleWQI = ref(false);
const toggleDischargeWater = ref(false);
const toggleDrain = ref(false);
const toggleDam = ref(false);
const togglePumpStation = ref(false);
const toggleAutomaticMeasuringStation = ref(false);
const onFocusPlace = ref({ lat: "", long: "" });
const dataType = ref<any>([]);
const dataChart = ref<any>([]);
const dataChartWithTypeId = ref<any>([]);
const dataAllPlaceWithTypeId = ref<any>([]);
const dischargeWaterPoints = ref<any>([]);
const drains = ref<any>([]);
const dams = ref<any>([]);
const pumpStations = ref<any>([]);
const automaticMeasuringStations = ref<any>([]);

export const usePlace = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  const checkRangeAB = (number: any, ranges: any) => {
    for (let i = 0; i < ranges.length; ++i) {
      if (number < ranges[i]) {
        return i;
      }
    }
  };
  const getPlaceDetail = async (id = 1) => {
    try {
      const res = await services.getPlacesDetail(id);
      if (res.status === 200) {
        places.value = res.data.data;

        for (let i = 0; i < dataType.value.length; i++) {
          const findData = places.value.find(
            (d: any) => dataType.value[i].id === d.data_type_id
          );
          if (!findData) {
            places.value.push({
              data_type_id: dataType.value[i].id,
              data_value: 0
            });
          }
        }
        for (let i = 0; i < places.value.length; i++) {
          const data_type = dataType.value.find(
            (d: any) => d.id === places.value[i].data_type_id
          );
          places.value[i].data_type = data_type;
          places.value[i].label = places.value[i].data_type.name
            ? places.value[i].data_type.name
            : "";
          places.value[i].show = false;
          places.value[i].value = places.value[i].data_value
            ? places.value[i].data_value
            : 0;
          places.value[i]["valueCheckRange"] = 0;
          places.value[i]["pointRange"] = "A1";
          if (places.value[i]["value"]) {
            const valueRange = parseFloat(
              places.value[i]["value"]
                .replaceAll(",", ".")
                .match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)
            );
            if (!isNaN(valueRange)) {
              places.value[i]["valueCheckRange"] = valueRange;
            }
            const isRangeAB = checkRangeAB(
              places.value[i]["valueCheckRange"],
              places.value[i].data_type.rangeAB
            );
            if (isRangeAB === 0) places.value[i]["pointRange"] = "A1";
            else if (isRangeAB === 1) places.value[i]["pointRange"] = "A2";
            else if (isRangeAB === 2) places.value[i]["pointRange"] = "B1";
            else places.value[i]["pointRange"] = "B2";
          }
        }
        return res.data;
      }
      return res;
    } catch (e) {
      console.log(e);
    }
  };

  const initPlaceDetail = async (id = 83) => {
    try {
      const res = await services.getPlacesDetail(id);
      let data: any[] = [];
      if (res.status === 200) {
        data = res.data.data;
        for (let i = 0; i < data.length; i++) {
          const data_type = dataType.value.find(
            (d: any) => d.id === data[i].data_type_id
          );
          data[i].data_type = data_type;
          data[i].label = data[i].data_type.name ? data[i].data_type.name : "";
          data[i].show = false;
          data[i].value = data[i].data_value ? data[i].data_value : 0;
          data[i]["valueCheckRange"] = 0;
          data[i]["pointRange"] = "A1";
          if (data[i]["value"]) {
            const valueRange = parseFloat(
              data[i]["value"]
                .replaceAll(",", ".")
                .match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)
            );
            if (!isNaN(valueRange)) {
              data[i]["valueCheckRange"] = valueRange;
            }
            const isRangeAB = checkRangeAB(
              data[i]["valueCheckRange"],
              data[i].data_type.rangeAB
            );
            if (isRangeAB === 0) data[i]["pointRange"] = "A1";
            else if (isRangeAB === 1) data[i]["pointRange"] = "A2";
            else if (isRangeAB === 2) data[i]["pointRange"] = "B1";
            else data[i]["pointRange"] = "B2";
          }
        }
        return data;
      }
      return data;
    } catch (e) {
      console.log(e);
      return [];
    }
  };

  const getDataType = async () => {
    try {
      const res = await services.getDataType();
      if (res.status === 200) {
        dataType.value = res.data.data;
        for (let i = 0; i < dataType.value.length; i++) {
          const current = dataType.value[i];
          dataType.value[i].configObj = JSON.parse(current.config);
          // handle range
          dataType.value[i].range = [];
          Object.keys(dataType.value[i].configObj).forEach(function(key) {
            if (key.substring(0, 5) === "RANGE")
              dataType.value[i].range.push(
                parseFloat(dataType.value[i].configObj[key])
              );
          });
          dataType.value[i].range.sort((a: any, b: any) => {
            return a - b;
          });
          // handle A1 A2 B1 B2
          dataType.value[i].rangeAB = [];
          if (dataType.value[i].name === "pH") {
            dataType.value[i].rangeAB = dataType.value[i].range;
          } else {
            if (dataType.value[i].configObj.A1) {
              const a1Data = parseFloat(
                dataType.value[i].configObj.A1.replaceAll(",", ".").match(
                  /-?(?:\d+(?:\.\d*)?|\.\d+)/
                )
              );
              if (!isNaN(a1Data)) {
                dataType.value[i].rangeAB.push(a1Data);
              }
            }
            if (dataType.value[i].configObj.A2) {
              const a2Data = parseFloat(
                dataType.value[i].configObj.A2.replaceAll(",", ".").match(
                  /-?(?:\d+(?:\.\d*)?|\.\d+)/
                )
              );
              if (!isNaN(a2Data)) {
                dataType.value[i].rangeAB.push(a2Data);
              }
            }
            if (dataType.value[i].configObj.B1) {
              const b1Data = parseFloat(
                dataType.value[i].configObj.B1.replaceAll(",", ".").match(
                  /-?(?:\d+(?:\.\d*)?|\.\d+)/
                )
              );
              if (!isNaN(b1Data)) {
                dataType.value[i].rangeAB.push(b1Data);
              }
            }
            if (dataType.value[i].configObj.B2) {
              const b2Data = parseFloat(
                dataType.value[i].configObj.B2.replaceAll(",", ".").match(
                  /-?(?:\d+(?:\.\d*)?|\.\d+)/
                )
              );
              if (!isNaN(b2Data)) {
                dataType.value[i].rangeAB.push(b2Data);
              }
            }
          }
          dataType.value[i].rangeAB.sort((a: any, b: any) => {
            return a - b;
          });
        }
        if (dataType.value.length > 0) {
          const findIndexPH = dataType.value.findIndex((t: any) => t.id === 1);
          if (findIndexPH > -1) {
            const checkHasData = dataType.value[findIndexPH]["range"].findIndex(
              (d: any) => d == 14
            );
            if (checkHasData < 0) {
              dataType.value[findIndexPH]["range"].push(14);
            }
          }
        }
      }
      return res;
    } catch (e) {
      console.log(e);
    }
  };

  const markers = computed(() => {
    let res: any[] = [];
    zones.value.forEach((z: any) => {
      // if (z.show) {
      res = [...res, ...z.places];
      // }
    });
    return res;
  });

  const getZones = async () => {
    try {
      const textZoneId2 =
        "106.128081999966,20.2683379998046 106.120733999966,20.2685879998047 106.118288999966,20.2681109998047 106.116497999966,20.2673319998047 106.115523999966,20.2665589998047 106.114223999966,20.2656309998047 106.113250999966,20.2645519998047 106.108868999966,20.2606919998047 106.105945999966,20.2586719998047 106.103677999966,20.2566499998048 106.103189999966,20.2564909998048 106.101242999966,20.2550879998048 106.100107999966,20.2541529998048 106.097352999966,20.2518189998048 106.095873999966,20.2533409998048 106.094890999966,20.2539449998048 106.094009999966,20.2541579998048 106.092440999966,20.2543799998048 106.090972999966,20.2543649998048 106.088856999966,20.2537279998048 106.087394999966,20.2529439998048 106.086391999966,20.2521319998048 106.085143999966,20.2503579998048 106.083680999966,20.2473699998048 106.083047999966,20.2452359998048 106.082314999966,20.2434419998049 106.081455999966,20.2405849998049 106.079537999966,20.2365099998049 106.077664999966,20.2337349998049 106.076901999966,20.232605999805 106.075950999966,20.231461999805 106.074926999966,20.229799999805 106.071131999966,20.226026999805 106.070647999966,20.225738999805 106.069997999966,20.225091999805 106.067449999966,20.223523999805 106.058880999966,20.2182919998051 106.058846999966,20.2183239998051 106.054160999966,20.2169029998051 106.050950999966,20.2166959998051 106.048154999966,20.2170999998051 106.045158999966,20.2182769998051 106.042642999966,20.2197269998051 106.041168999966,20.2204789998051 106.036924999966,20.223416999805 106.031643999966,20.228829999805 106.029988999966,20.231732999805 106.029317999966,20.2340309998049 106.028860999966,20.2364489998049 106.029605999966,20.2387989998049 106.031551999966,20.2402039998049 106.033837999966,20.2406409998049 106.037087999966,20.2413399998049 106.041332999966,20.2407709998049 106.043290999966,20.2406379998049 106.046202999966,20.2415669998049 106.047842999966,20.2425319998049 106.048811999966,20.2437719998049 106.049126999966,20.2451589998049 106.048950999966,20.2466939998048 106.048780999966,20.2476139998048 106.047757999966,20.2495479998048 106.046627999966,20.2517409998048 106.046252999966,20.2524629998048 106.044540999966,20.2534979998048 106.043079999966,20.2544729998048 106.041216999966,20.2552179998048 106.037242999966,20.2547329998048 106.033679999966,20.2528859998048 106.030700999966,20.2514859998048 106.027388999966,20.2507649998048 106.023967999966,20.2502659998048 106.023151999966,20.2502569998048 106.020377999966,20.2503809998048 106.016489999966,20.2502469998048 106.013724999966,20.2503279998048 106.005036999966,20.2514429998048 106.003521999966,20.2515559998048 106.002750999966,20.2517249998048 106.001683999966,20.2519109998048 106.000951999967,20.2523199998048 105.999843999966,20.2525419998048 105.993615999966,20.2550799998048 105.991498999967,20.2560159998047 105.987199999967,20.2586159998047 105.985866999967,20.2598529998047 105.983652999967,20.2612039998047 105.981423999967,20.2620769998047 105.981100999967,20.2623869998047 105.980778999967,20.2628499998047 105.980950999967,20.2634629998047 105.980637999967,20.2645409998047 105.981163999967,20.2671499998047 105.981509999967,20.2685299998046 105.981599999967,20.2697849998046 105.982031999967,20.2708319998046 105.982713999967,20.2728249998046 105.983561999967,20.2749699998046 105.984671999966,20.2769629998046 105.985296999967,20.2788759998046 105.986233999966,20.2815469998045 105.986217999966,20.2850899998045 105.985469999967,20.2879869998045 105.984868999967,20.2899429998045 105.983658999967,20.2925539998044 105.982826999967,20.2943299998044 105.981555999966,20.2964959998044 105.979624999967,20.2991209998044 105.977659999967,20.3015189998044 105.975946999967,20.3033359998044 105.974778999967,20.3043779998043 105.972140999967,20.3077329998043 105.968746999967,20.3104269998043 105.966211999967,20.3131939998043 105.962963999967,20.3153669998042 105.961176999967,20.3166079998042 105.959382999967,20.3172339998042 105.957912999967,20.3175509998042 105.954657999967,20.3192629998042 105.953356999967,20.3200399998042 105.952703999967,20.3201979998042 105.952215999967,20.3205089998042 105.950749999967,20.3211329998042 105.944880999967,20.3234759998042 105.941943999967,20.3244169998042 105.939827999967,20.3255069998042 105.935637999967,20.3276569998041 105.936086999967,20.3291189998041 105.936438999967,20.3301839998041 105.939246999967,20.3317779998041 105.941878999967,20.3328299998041 105.943224999967,20.3334739998041 105.947711999967,20.3360889998041 105.950016999967,20.339647999804 105.951254999967,20.341898999804 105.952156999967,20.343679999804 105.952831999967,20.345884999804 105.953768999967,20.3496209998039 105.954300999967,20.3514729998039 105.954286999967,20.3532659998039 105.953824999967,20.3544799998039 105.950716999967,20.3553529998039 105.946887999967,20.3549719998039 105.941017999967,20.3554179998039 105.940092999967,20.3555799998039 105.938443999967,20.3560169998039 105.937554999967,20.3567479998039 105.937273999967,20.3578319998039 105.937096999967,20.3613729998039 105.936735999967,20.3644579998038 105.936592999967,20.3649239998038 105.936316999967,20.3666469998038 105.935796999967,20.3675059998038 105.935368999967,20.3677329998038 105.933579999967,20.3671709998038 105.931418999967,20.3663179998038 105.930079999967,20.3655919998038 105.928753999967,20.3651729998038 105.926027999967,20.3638349998038 105.923423999967,20.3628839998038 105.920849999967,20.3633499998038 105.920037999967,20.3643819998038 105.919282999967,20.3655679998038 105.918555999967,20.3676489998038 105.917352999967,20.3709219998038 105.916945999967,20.3718979998038 105.916317999967,20.3718329998038 105.913901999967,20.3736369998037 105.912182999967,20.3755359998037 105.911692999967,20.3755519998037 105.910321999967,20.3740579998037 105.909107999967,20.3724069998038 105.908597999967,20.3719619998038 105.906337999967,20.3726479998038 105.903580999967,20.3731969998038 105.901470999967,20.3735709998037 105.900359999967,20.3743749998037 105.897926999967,20.3787549998037 105.895743999967,20.3812829998037 105.893479999967,20.3858109998036 105.890799999967,20.3882009998036 105.888526999967,20.3885809998036 105.887376999967,20.3884629998036 105.886957999967,20.3901669998036 105.884811999967,20.3936159998036 105.881817999967,20.3963229998036 105.880222999967,20.3972949998035 105.879614999967,20.3983899998035 105.879332999967,20.3994749998035 105.878410999967,20.4008869998035 105.877821999967,20.4024429998035 105.877219999967,20.4036909998035 105.874708999967,20.4062289998035 105.872956999967,20.4073599998035 105.869590999967,20.4090029998034 105.868511999967,20.4105739998034 105.868229999967,20.4116589998034 105.868123999967,20.4130449998034 105.867083999967,20.4155369998034 105.866160999967,20.4169489998034 105.865042999967,20.4175989998034 105.863264999967,20.4181159998034 105.862303999967,20.4186079998034 105.861532999967,20.4197079998034 105.860529999967,20.4231199998033 105.859770999967,20.4245269998033 105.858665999967,20.4254839998033 105.856749999967,20.4266199998033 105.856762999967,20.4269269998033 105.855702999967,20.4289579998033 105.854346999967,20.4319159998033 105.853610999967,20.4383769998032 105.852991999967,20.4436079998032 105.853346999967,20.4443619998031 105.852874999967,20.4448379998032 105.852938999967,20.4465209998031 105.853599999967,20.4510969998031 105.853454999967,20.4515609998031 105.853283999967,20.455704999803 105.852641999967,20.460322999803 105.852360999967,20.465849999803 105.851986999967,20.4689269998029 105.851296999967,20.4766119998029 105.851022999967,20.4780009998029 105.851703999967,20.4787439998029 105.853582999967,20.4809809998028 105.854112999967,20.4820359998028 105.853960999967,20.4823469998028 105.853644999967,20.4869549998028 105.854162999967,20.4877039998028 105.857660999967,20.4895799998028 105.861299999967,20.4908389998028 105.862795999967,20.4915549998027 105.863271999967,20.4955239998027 105.863055999967,20.4984429998027 105.863264999967,20.4996619998027 105.862787999967,20.4999839998027 105.862778999967,20.5040909998026 105.863703999967,20.5069679998026 105.864221999967,20.5077169998026 105.865234999967,20.5086039998026 105.86699383923,20.5098489575249 105.872835089865,20.5105946490953 105.874450754934,20.5109053539163 105.875693574218,20.5107189310237 105.875817856147,20.5118996093436 105.877917999967,20.5115779998026 105.877940999967,20.5121889998026 105.877677999967,20.5138799998026 105.876127999967,20.5160689998025 105.877135999967,20.5168029998025 105.878399999967,20.5156929998025 105.879703999967,20.5156529998025 105.880384999967,20.5163969998025 105.881229999967,20.5171349998025 105.882359999967,20.5167949998025 105.882825999967,20.5161679998025 105.882644999967,20.5157149998025 105.882790999967,20.5152519998025 105.883834040529,20.5140434726086 105.885139000777,20.5153484328568 105.888618894772,20.5187040449238 105.888183908023,20.5196361593868 105.889799573092,20.5219353750623 105.891663802018,20.5252288461651 105.894335863479,20.5283980353394 105.896262233369,20.5287087401604 105.892347352625,20.5336178763324 105.894211581551,20.5351092594733 105.891912365875,20.5386512944328 105.889923855021,20.5393659155212 105.888556753808,20.5406708757694 105.888867458629,20.5422865408387 105.889426727307,20.543591501087 105.891228815269,20.5453314480846 105.893217326123,20.5469471131539 105.891477379126,20.5485627782232 105.892533775517,20.5506134300419 105.895951528548,20.5520426722185 105.893652312873,20.5562682577843 105.891415238162,20.558940319245 105.89390087673,20.5599967156365 105.894025158658,20.5640980192739 105.895205836978,20.5653408385579 105.898872153866,20.566583657842 105.898996435794,20.5681993229112 105.902289906897,20.5686964506249 105.903408444253,20.5673293494124 105.903781290038,20.5654029795221 105.907074761141,20.5639737373455 105.909187553924,20.5688207325533 105.910181809351,20.5706228205151 105.912046038277,20.5716792169066 105.913537421418,20.571182089193 105.91490452263,20.567826477126 105.914966663594,20.5627309180614 105.917390161198,20.5642844421665 105.918570839518,20.5650922747011 105.918260134697,20.5678886180902 105.919689376874,20.5673293494124 105.923044988941,20.5673914903766 105.924039244368,20.5711199482288 105.940444458917,20.5724870494412 105.943924352913,20.5656515433789 105.946534273409,20.5667700807346 105.948274220407,20.5654029795221 105.948398502335,20.5603074204575 105.948305290889,20.5581014162283 105.94861599571,20.5567032445337 105.947839233658,20.5545283107866 105.946441061963,20.5518251788438 105.945879755877,20.5515297545878 105.945912863767,20.5514834035407 105.945336999967,20.5494679998023 105.944774999967,20.5476419998023 105.945058999967,20.5465589998023 105.945844999967,20.5457689998023 105.948111999967,20.5452419998023 105.954972999967,20.5451979998023 105.957444999967,20.5457399998023 105.959396999967,20.5466209998023 105.962057999967,20.5490449998023 105.968561999967,20.5540749998022 105.968738999967,20.5548319998022 105.968743999967,20.5556719998022 105.968606999967,20.5566749998022 105.968474999967,20.5585719998022 105.968708999967,20.5592479998022 105.969514999967,20.5592709998022 105.971144999967,20.5577989998022 105.972988999966,20.5582759998022 105.974833999966,20.5589699998022 105.977676999966,20.5607109998022 105.981105999966,20.5624469998022 105.983565999966,20.5633699998021 105.984282999966,20.5637019998021 105.984873999966,20.5639179998021 105.985754999966,20.5641779998021 105.987454999966,20.5649819998021 105.987804999966,20.5655859998021 105.988004999966,20.5665009998021 105.988506999966,20.5667939998021 105.989969999966,20.5665979998021 105.992671999966,20.5646769998021 105.993795999966,20.5641829998021 105.995252999966,20.5638339998021 105.996068999966,20.5638099998021 105.998166999966,20.5631349998022 106.000157999966,20.5615359998022 106.002765999966,20.5592339998022 106.003752999966,20.5601579998022 106.004906999966,20.5621589998022 106.005571999966,20.5643129998021 106.005411999966,20.5652359998021 106.003949999966,20.5676939998021 106.003298999966,20.5684619998021 106.002974999966,20.5692299998021 106.002166999966,20.5715359998021 106.002333999966,20.5723049998021 106.001252999966,20.5723109998021 106.000685999966,20.5723739998021 106.000112999966,20.5726999998021 105.998304999966,20.5736239998021 105.997234999966,20.5742369998021 105.995893999966,20.5746499998021 105.994419999966,20.575265999802 105.990643999966,20.577362999802 105.987624999966,20.580061999802 105.985413999966,20.583060999802 105.983711999966,20.585904999802 105.982600999966,20.5886949998019 105.981891999966,20.5912549998019 105.981552999966,20.5929529998019 105.981246999966,20.5954849998019 105.981339999966,20.5992119998018 105.981801999966,20.6026299998018 105.982563999966,20.6046089998018 105.983417999966,20.6064989998018 105.984978999966,20.6090449998018 105.986488999966,20.6109309998017 105.988142999966,20.6134339998017 105.990880999966,20.6184639998017 105.992611999966,20.6208699998017 105.993833999966,20.6228299998016 105.995091999966,20.6257109998016 105.995430999966,20.6260079998016 105.996434999966,20.6265929998016 105.997747999966,20.6267079998016 105.998878999966,20.6264079998016 106.000178999966,20.6251849998016 106.001240999966,20.6239779998016 106.002309999966,20.6207959998017 106.003162999966,20.6190679998017 106.004817999966,20.6173919998017 106.006825999966,20.6162769998017 106.007788999966,20.6155939998017 106.011197999966,20.6147799998017 106.012329999966,20.6149859998017 106.015107999966,20.6150859998017 106.017827999966,20.6157859998017 106.019724999966,20.6161609998017 106.021828999966,20.6171329998017 106.023989999966,20.6178589998017 106.027071999966,20.6187689998017 106.032019999966,20.6192539998017 106.032674999966,20.6192549998017 106.032842999966,20.6201779998017 106.033335999966,20.6204859998017 106.037595999966,20.6209529998017 106.041845999966,20.6195749998017 106.044936659811,20.621181858671 106.046269999966,20.6201959998017 106.049689999966,20.6162019998017 106.052785999966,20.6131299998017 106.056075039588,20.6093958986748 106.059831004861,20.60758267406 106.06540019475,20.6048628371378 106.075243414087,20.6030496125231 106.079517443536,20.6036971927426 106.085734213644,20.6083597703235 106.090655823313,20.6118567035092 106.095032999966,20.6149599998017 106.095673999966,20.6152379998017 106.095858999966,20.6152529998017 106.096304999966,20.6155129998017 106.099963999966,20.6171029998017 106.101108999966,20.6173939998017 106.104876999966,20.6178499998017 106.108464279351,20.6185915377927 106.111702180449,20.6185267797707 106.114374999966,20.6179929998017 106.118566530776,20.6175554094414 106.122069999966,20.6178309998017 106.123369999966,20.6159889998017 106.123584999966,20.6156829998017 106.124507999966,20.6144549998017 106.126207977367,20.6134756540581 106.127567895828,20.6119862195531 106.129640152531,20.6094606566968 106.130805796926,20.6069350938405 106.130870554948,20.6030496125231 106.13061152286,20.5992936472496 106.130676280882,20.5954081659321 106.129575394509,20.5915226846147 106.129251604399,20.5840107540678 106.129899184619,20.5799957567064 106.130978999966,20.577338999802 106.131906683299,20.5751389050597 106.13359039187,20.5728723742912 106.136180712748,20.5713181817642 106.141296596483,20.5694401991275 106.146736270327,20.5688573769299 106.150038929447,20.5687278608859 106.151598999966,20.5685689998021 106.154699999966,20.5670319998021 106.157874650104,20.5658785079198 106.160853519114,20.5625110907781 106.162407711641,20.5587551255046 106.165839886805,20.555193434297 106.168106417573,20.5524088393528 106.169854884166,20.5500127925404 106.171020528561,20.5482643259476 106.172093999966,20.5455389998023 106.173999397571,20.5418532817739 106.176330686362,20.5346003833147 106.176978266581,20.5306501439753 106.177755362845,20.5282540971629 106.179180039328,20.5204831345281 106.179827619547,20.5165976532107 106.179309555372,20.5119350756298 106.178467701086,20.5058478215659 106.178532459108,20.4987244391506 106.178661975152,20.4946446837674 106.180604715811,20.4892697679449 106.181459999966,20.4867639998028 106.182064999966,20.4857589998028 106.183365999966,20.4843759998028 106.187927999966,20.4809949998028 106.189886999966,20.4803809998029 106.192193999966,20.4800089998029 106.196758999966,20.4795269998029 106.200687999966,20.4790979998029 106.206419999966,20.4782219998029 106.211329999966,20.4778009998029 106.214280999966,20.4769009998029 106.217234999966,20.4756919998029 106.220193999966,20.4737129998029 106.222338999966,20.4712639998029 106.223996999966,20.468348999803 106.224831999966,20.466042999803 106.225611541071,20.4620713987231 106.224834444807,20.4572793050983 106.222373639973,20.450155922683 106.219006222831,20.4434210883995 106.215250257558,20.4375928664234 106.211753324372,20.4325417407108 106.210717196021,20.4312465802716 106.209551551626,20.4293038396129 106.207536146011,20.4301945298989 106.207269999966,20.4295519998033 106.207028999966,20.4290889998033 106.206817999966,20.4256379998033 106.208346999966,20.4194449998034 106.211078999966,20.4167219998034 106.210003999966,20.4162759998034 106.209355999966,20.4154999998034 106.207565999966,20.4144059998034 106.207403999966,20.4142499998034 106.206579999966,20.4150139998034 106.205917999966,20.4160879998034 106.205424999966,20.4163919998034 106.202483999966,20.4162119998034 106.201825999966,20.4166689998034 106.201818999966,20.4175939998034 106.199851999966,20.4181939998034 106.199034999966,20.4181869998034 106.198710999966,20.4177219998034 106.198713999966,20.4174139998034 106.197242999966,20.4172469998034 106.197086999966,20.4163209998034 106.197429999966,20.4143189998034 106.197105999966,20.4138539998034 106.194659999966,20.4130619998034 106.194498999966,20.4127529998034 106.194677999966,20.4107499998035 106.194873999966,20.4065889998035 106.194547999966,20.4064319998035 106.193402999966,20.4065759998035 106.192912999966,20.4064179998035 106.192921999966,20.4053389998035 106.192760999966,20.4050289998035 106.192955999966,20.4010229998035 106.193283999966,20.4008709998035 106.195574999966,20.4005819998035 106.195926999966,20.3973479998036 106.195766999966,20.3968839998036 106.195277999966,20.3967259998036 106.194461999966,20.3965639998036 106.194300999966,20.3962549998036 106.194473999966,20.3950229998036 106.195647999966,20.3911789998036 106.195819999966,20.3901009998036 106.195495999966,20.3897899998036 106.194026999966,20.3894689998036 106.191743999966,20.3886789998036 106.191583999966,20.3882149998036 106.190938999966,20.3871299998036 106.190617999966,20.3863559998037 106.191124999966,20.3842019998037 106.191633999966,20.3806639998037 106.189839999966,20.3786479998037 106.187057999966,20.3761509998037 106.186330999966,20.3764869998037 106.185089999966,20.3766479998037 106.182816999966,20.3763069998037 106.182643999966,20.3758189998037 106.182485999966,20.3742779998038 106.181666999966,20.3744249998038 106.180353999966,20.3748769998038 106.179668999966,20.3780099998037 106.179590999966,20.3819079998037 106.179933999966,20.3843769998037 106.181626999966,20.3842799998037 106.182773999966,20.3841349998037 106.183100999966,20.3842919998037 106.182925999966,20.3870619998037 106.181117999966,20.3884329998036 106.180625999966,20.3885829998036 106.179807999966,20.3884229998036 106.179314999966,20.3887269998036 106.179304999966,20.3905749998036 106.178155999966,20.3911819998036 106.177823999966,20.3917959998036 106.178611999966,20.3955029998036 106.177776999966,20.3978079998036 106.177909999966,20.4016639998035 106.178220999966,20.4036709998035 106.178216999966,20.4041329998035 106.174280999966,20.4056409998035 106.171661999966,20.4060799998035 106.171333999966,20.4062319998035 106.170689999966,20.4049929998035 106.170691999966,20.4046839998035 106.169558999966,20.4032869998035 106.167629999966,20.3991069998036 106.164868999966,20.3956939998036 106.161279999966,20.3919699998036 106.160146999966,20.3902149998036 106.158438999966,20.3877549998036 106.157192999966,20.3846869998037 106.155761999966,20.3803019998037 106.154290999966,20.3786699998037 106.153812999966,20.3755869998037 106.153167999966,20.3732719998038 106.152363999966,20.3695699998038 106.152051999966,20.3660249998038 106.152227999966,20.3631009998038 106.153712999966,20.3604949998039 106.155191999966,20.3592759998039 106.157654999966,20.3580639998039 106.159620999966,20.3579259998039 106.160600999966,20.3585499998039 106.161740999966,20.3600989998039 106.162549999966,20.3625689998039 106.163528999966,20.3633469998039 106.164509999966,20.3638169998038 106.165984999966,20.3636749998039 106.167957999966,20.3618429998039 106.168454999966,20.3606149998039 106.167938999966,20.3573149998039 106.165534999966,20.3538159998039 106.164231999966,20.3519579998039 106.164070999966,20.351339999804 106.163094999966,20.349638999804 106.162120999966,20.347474999804 106.161638999966,20.345314999804 106.161323999966,20.342386999804 106.161494999966,20.340694999804 106.161989999966,20.339774999804 106.162320999966,20.3390069998041 106.163470999966,20.3380929998041 106.165928999966,20.3376509998041 106.167403999966,20.3375079998041 106.168388999966,20.3369009998041 106.168881999966,20.3364429998041 106.168888999966,20.3349029998041 106.168725999966,20.3347469998041 106.168893999966,20.3335169998041 106.168988999966,20.3330779998041 106.168278999966,20.3300519998041 106.166031999966,20.3273599998042 106.162003999966,20.3247729998042 106.159411999966,20.3223159998042 106.158165999966,20.3210639998042 106.158115999966,20.3210169998042 106.157268999966,20.3201829998042 106.154975999966,20.3179569998042 106.151186999966,20.3141549998043 106.148387999966,20.3105809998043 106.146925999966,20.3093449998043 106.144499999966,20.3056539998043 106.143686999966,20.3051889998043 106.143044999966,20.3033469998044 106.142239999966,20.3015049998044 106.141604999966,20.2985919998044 106.141465999966,20.2947639998044 106.142476999966,20.2897209998045 106.142654999966,20.2872729998045 106.143324999966,20.2845229998045 106.143667999966,20.2819239998045 106.143203999966,20.2777879998046 106.142243999966,20.2747199998046 106.141596999966,20.2736439998046 106.141599999966,20.2731839998046 106.139657999966,20.2705679998046 106.137707999966,20.2690229998046 106.135916999966,20.2683969998047 106.133143999966,20.2680699998047 106.129877999966,20.2681979998047 106.128081999966,20.2683379998046";
      const myArrayId2 = textZoneId2.split(" ");
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const pointId2 = [];
      myArrayId2.forEach(p => {
        const newa = p.split(",");
        pointId2.push({ lat: parseFloat(newa[1]), lng: parseFloat(newa[0]) });
      });
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const res = await services.getZones();
      if (res.status === 200) {
        zones.value = res.data.data;
        zones.value.forEach((z: any) => {
          z.show = false;
          z.polygon = JSON.parse(z.config);
        });
      }
      return res;
    } catch (e) {
      console.log(e);
    }
  };

  const getDataChart = async (id = 1) => {
    if (dataChart.value.length > 2 && dataChart.value[1]["place_id"] === id)
      return;
    try {
      const res = await services.getPlacesDetailUseChart(id);
      if (res.status === 200) {
        dataChart.value = res.data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleDataWithDataType = async (id = 1) => {
    dataChartWithTypeId.value = dataChart.value.filter(
      (d: any) => d.data_type_id === id
    );
  };
  const getValueAllPlaceWithDataType = async (id = 1) => {
    console.log("id", id);
    try {
      const findIndex = dataAllPlaceWithTypeId.value.findIndex(
        (d: any) => d.data_type_id === id
      );

      if (findIndex < 0) {
        const res = await services.getValueAllPlaceWithDataType(id);
        if (res.status === 200) {
          const data: any = [];
          const findRule = dataType.value.find((d: any) => d.id === id);
          if (findRule && findRule.id === 37)
            findRule.rangeAB = [25, 50, 75, 90, 100];
          if (res.data.data.length > 0 && findRule) {
            for (let i = 0; i < res.data.data.length; i++) {
              // data
              const dataFormatTypeAndLatLong = res.data.data[i]["place"];
              dataFormatTypeAndLatLong.data_value =
                res.data.data[i]["data_value"];
              dataFormatTypeAndLatLong.data_type_id = id;
              let resRange = findRule.rangeAB.findIndex((val: any) => {
                return val >= dataFormatTypeAndLatLong.data_value;
              });
              if (resRange <= -1) {
                resRange = findRule.rangeAB.length - 1;
              }
              dataFormatTypeAndLatLong.resRange = resRange;
              data.push(dataFormatTypeAndLatLong);
            }
          }
          dataAllPlaceWithTypeId.value.push({
            data_type_id: id,
            data: data
          });
        }
      } else {
        const old = dataAllPlaceWithTypeId.value[findIndex];
        dataAllPlaceWithTypeId.value.splice(findIndex, 1);
        dataAllPlaceWithTypeId.value.push(old);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const removeValueAllPlaceWithDataType = async (id = 1) => {
    try {
      const findIndex = dataAllPlaceWithTypeId.value.findIndex(
        (d: any) => d.data_type_id === id
      );
      if (findIndex > -1) {
        dataAllPlaceWithTypeId.value.splice(findIndex, 1);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const doSearchPlace = async (name: any) => {
    try {
      const res = await services.searchPlaces(name);
      if (res.status === 200) {
        return res.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getDischargeWaterPoint = async () => {
    const selectedZones = zones.value.filter((e: any) => e.show);
    if (selectedZones.length > 0 && toggleDischargeWater.value === true) {
      const res = await services.getDischargeWaterPoints(
        selectedZones.map((e: any) => e.id).join(",")
      );
      if (res.status === 200) {
        dischargeWaterPoints.value = res.data.data;
      }
    } else {
      dischargeWaterPoints.value = [];
    }
  };

  const getDrains = async () => {
    const selectedZones = zones.value.filter((e: any) => e.show);
    if (selectedZones.length > 0 && toggleDrain.value === true) {
      const res = await services.getDrains(
        selectedZones.map((e: any) => e.id).join(",")
      );
      if (res.status === 200) {
        drains.value = res.data.data;
      }
    } else {
      drains.value = [];
    }
  };

  const getDams = async () => {
    const selectedZones = zones.value.filter((e: any) => e.show);
    if (selectedZones.length > 0 && toggleDam.value === true) {
      const res = await services.getDams(
        selectedZones.map((e: any) => e.id).join(",")
      );
      if (res.status === 200) {
        dams.value = res.data.data;
      }
    } else {
      dams.value = [];
    }
  };

  const getPumpStations = async () => {
    const selectedZones = zones.value.filter((e: any) => e.show);
    if (selectedZones.length > 0 && togglePumpStation.value === true) {
      const res = await services.getPumpStations(
        selectedZones.map((e: any) => e.id).join(",")
      );
      if (res.status === 200) {
        pumpStations.value = res.data.data;
      }
    } else {
      pumpStations.value = [];
    }
  };

  const getAutomaticMeasuringStations = async () => {
    const selectedZones = zones.value.filter((e: any) => e.show);
    if (
      selectedZones.length > 0 &&
      toggleAutomaticMeasuringStation.value === true &&
      selectedZones.map((e: any) => e.id).includes(3)
    ) {
      // const res = await services.getPumpStations(
      //   selectedZones.map((e: any) => e.id).join(",")
      // );
      // if (res.status === 200) {
      //   automaticMeasuringStations.value = res.data.data;
      // }
      automaticMeasuringStations.value = [
        {
          matramtudong: "tdd_nq_hd",
          tentram: "Công ty cổ phần Đầu tư và Phát triển hạ tầng Nam Quang",
          address:
            "Khu CN Nam Sách, phường Ái Quốc, TP. Hải Dương, tỉnh Hải Dương",
          phone: "02.203.752.001",
          license: "Số 51/GP-TCTL_QLCT",
          expire_date: "03/02/2024",
          madiemdo: "ttd_nq_hd_nt",
          lat: "20.92531681",
          long: "106.194381",
          type_code: "nt",
          type: "Nguồn nước thải",
          flow_rate: "1500"
        },
        {
          matramtudong: "tdd_nq_hd",
          tentram: "Công ty cổ phần Đầu tư và Phát triển hạ tầng Nam Quang",
          address:
            "Khu CN Nam Sách, phường Ái Quốc, TP. Hải Dương, tỉnh Hải Dương",
          phone: "02.203.752.001",
          license: "Số 51/GP-TCTL_QLCT",
          expire_date: "03/02/2024",
          madiemdo: "ttd_nq_hd_tn_01",
          lat: "20.926378",
          long: "106.193607",
          type_code: "tn",
          type: "Nguồn tiếp nhận",
          ngaydodac: "12/1/2023"
        },
        {
          matramtudong: "tdd_nq_hd",
          tentram: "Công ty cổ phần Đầu tư và Phát triển hạ tầng Nam Quang",
          address:
            "Khu CN Nam Sách, phường Ái Quốc, TP. Hải Dương, tỉnh Hải Dương",
          phone: "02.203.752.001",
          license: "Số 51/GP-TCTL_QLCT",
          expire_date: "03/02/2024",
          madiemdo: "ttd_nq_hd_tn_02",
          lat: "20.924734",
          long: "106.195227",
          type_code: "tn",
          type: "Nguồn tiếp nhận",
          ngaydodac: "10/1/2023"
        }
      ];
    } else {
      automaticMeasuringStations.value = [];
    }
  };

  return {
    places,
    zones,
    selectedZones,
    markers,
    markerSelected,
    toggleWQI,
    toggleDischargeWater,
    toggleDrain,
    toggleDam,
    togglePumpStation,
    toggleAutomaticMeasuringStation,
    dataChartWithTypeId,
    dataAllPlaceWithTypeId,
    dischargeWaterPoints,
    drains,
    dams,
    pumpStations,
    automaticMeasuringStations,
    onFocusPlace,
    doSearchPlace,
    getValueAllPlaceWithDataType,
    getPlaceDetail,
    handleDataWithDataType,
    getZones,
    getDataType,
    getDataChart,
    initPlaceDetail,
    removeValueAllPlaceWithDataType,
    getDischargeWaterPoint,
    getDrains,
    getDams,
    getPumpStations,
    getAutomaticMeasuringStations
  };
};
